export enum HistoricalEntityEnum {
	Appointment = 'Appointment',
	Insurance = 'Insurance',
	SalesOrder = 'SalesOrder',
	SalesOrderLine = 'SalesOrderLine',
	SerializedItem = 'SerializedItem',
	EndOfDay = 'EndOfDay'
}